<ng-container *ngIf="activeFilters.length">
  <div class="mr-8">
    <span>Filter{{activeFilters.length > 1 ? 's' : ''}} active</span>
  </div>

  <div *ngFor="let col of activeFilters" fxLayout="row" fxLayoutAlign="start center" class="active-filter-column" (click)="clearAccessFilter(col)">
    <span>{{col.name}}</span>
    <div class="ml-4 wee-icon smaller">
      <mat-icon>clear</mat-icon>
    </div>
  </div>

  <div *ngIf="activeFilters.length > 1" fxLayout="row" fxLayoutAlign="start center" class="active-filter-all" (click)="clearAccessFilter()">
    <span>Clear all</span>
    <div class="ml-4 wee-icon smaller">
      <mat-icon>clear</mat-icon>
    </div>
  </div>
</ng-container>
